import React from 'react';

import DrawerTitle from '../../DrawerTitle';
import LineItemNotes from '../LineItemNotes';

const LineItemNotesTab = ({ lineItemId }: { lineItemId?: string }): JSX.Element => {
  return (
    <>
      <DrawerTitle title="Line Item Notes" />
      <LineItemNotes lineItemId={lineItemId} />
    </>
  );
};

export default LineItemNotesTab;
